<template>
  <list-layout-two-columns-no-fixed :tableTools='false'>
    <template slot="header">
      <slot name="header" />
      <div class="px-4 lg:px-10 font-medium dark:text-white mb-2 flex gap-4 items-center">
        <h2>{{ step.description }}</h2>
        <el-form ref="ruleForm" class="flex-1" :model="form" :rules="rules">
          <el-form-item prop="invoiceLines">
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template slot='table-core'>
      <base-table-pagination-mini v-if="isLower1024"
        :total='pagination.total'
        :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize'
        @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'
      ></base-table-pagination-mini>
      <base-table-pagination v-else
        :total='pagination.total'
        :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize'
        @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'
      ></base-table-pagination>
      <div class="flex flex-row w-100 gap-4">
        <base-button-responsive v-if="isLower1024" size="xs" class="w-full md:w-auto" icon="plus" :text="$t('app.add')" @click="toggleImportProducts" :loading="isGeneralLoading" />
        <base-button-responsive v-else size="xs" class="w-full md:w-auto" icon="plus" :text="$t('invoices.invoices_issuing.step4.add_line')" @click="toggleImportProducts" :loading="isGeneralLoading" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot='table-tags'>
      <base-table-filter-tags hide-save :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot='table-component'>
      <kendo-grid-component
        ref="grid"
        :spanish="spanish"
        :data="data"
        :kendo="kendo"
        :loading="isGeneralLoading"
        :selectedField="selectedField"
        :inEditField="inEditField"
        :expandField="expandField"
        value-key="uuid"
        @datastatechange="dataStateChange"
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
          <template v-slot:kendorowdetail="{ scope, inEdit, save, cancel, edit }">
            <div class="custom-detail-row flex flex-row gap-2 w-full">
              <div>
                <div v-if="!inEdit" class="flex flex-col-reverse gap-4 h-full">
                  <div class="w-10/5 h-10/5 invisible"><!-- Div for pad editpencil button --></div>
                  <base-button-icon name="editpencil" size="md" icon-size="sm" @click="edit(true)" />
                </div>
                <div v-else class="flex flex-col-reverse gap-4 h-full">
                  <base-button-icon name="cross" size="md" icon-size="sm" @click="cancel(false)" />
                  <base-button-icon name="save" size="md" icon-size="sm" @click="checkLine(scope, save)" />
                </div>
              </div>
              <div class="flex flex-row gap-2 w-full">
                <div class="w-full">
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('invoices.invoices_issuing.step4.cantidad') }}</label>
                    <el-input clearable class="w-full" v-model="scope.cantidad" type="number" size="mini" :disabled="!inEdit" @input="e => controlCantidad(scope, e)" />
                  </div>
                  <base-ro-input class="mt-2" mini :label="$t('app.subtotal')" :data="formatNumberWithDefault(scope.subtotal)" />
                </div>
                <div class="w-full">
                  <div>
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.descuento_long') }}</label>
                    <el-input clearable class="w-full" v-model="scope.descuentos[0].descuento" type="number" size="mini" :disabled="!inEdit" @input="e => controlDescuento(scope, e)" />
                  </div>
                  <div class="mt-2">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.discount_cuota') }}</label>
                    <el-input clearable class="w-full" v-model="scope.descuentos[0].cuota" type="number" size="mini" :disabled="!inEdit" @input="e => controlCuota(scope, e)" />
                  </div>
                </div>
              </div>
              <div class="w-full">
                <div class="flex flex-row gap-2">
                  <div class="w-full">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('impuestos.entity_name') }}</label>
                    <!-- Quitar [0], cambiar [e] por e y agregar atributo múltiple para admitir varios impuestos -->
                    <base-el-select clearable class="w-full" v-model="scope.taxes[0]" size="mini" value-key="idImpuesto" :option-value="taxValue" :options="scope.impuestos" :disabled="!inEdit" @input="e => controlImpuestos(scope, [e])" />
                  </div>
                  <div class="w-full">
                    <base-ro-input class="flex-1" mini :label="$t('app.total_no_tax')" :data="formatNumberWithDefault(scope.total)" />
                  </div>
                </div>
                <div class="flex flex-row gap-2 mt-2">
                  <base-ro-input class="flex-1" mini :label="$t('invoices.invoices_issuing.tax_cuota')" :data="formatNumberWithDefault(scope.taxes[0].cuota)" />
                  <base-ro-input class="flex-1" mini :label="$t('app.total')" :data="formatNumberWithDefault(scope.totalConImpuesto)" />
                </div>
              </div>
            </div>
          </template>
      </kendo-grid-component>
    </template>
    <template slot='RightCol'>
      <slot name="invoice-summary" />
    </template>
    <template slot='layout-extend'>
      <filter-panel :panelOpen='filterPanel' @togglePanel='toggleFilters' @applyFilters='applyFiltersHandler' />
      <slot name="layout-extend" :valid="!!form.invoiceLines.length" />
      <base-table-select-actions-expand baseDropDownVisible :visibility="hasSelected"
        :selected="rowsSelected" :total="rowsTotal">
        <template slot="commons">
          <base-button size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" />
            {{$t('app.unselect')}}
          </base-button>
        </template>
        <template slot="more">
          <span>
            <base-button-item-list theme="dark" @click="deleteLines">
              <base-icon name="trash" class="mr-2" />
              <div class="w-72 text-left">{{ $t('app.remove') }}</div>
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <import-products-dialog :dialogOpen="ImportProductsDialog" :id-cliente="value" :mobile-version="isLower1024" @toggleDialog="toggleImportProducts" @applyDialog="importProducts" />
    </template>
  </list-layout-two-columns-no-fixed>
</template>

<script>
import { i18n } from '@/i18n'
import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

import ListLayoutTwoColumnsNoFixed from '@/components/layout/ListLayoutTwoColumnsNoFixed.vue'
import FilterPanel from '@/components/filters/Step4Filter.vue'
import KendoGridComponent from '@/components/KendoGridComponentV2.vue'
import ImportProductsDialog from '@/components/Step4ProductsDialog.vue'

import { getInvoiceLines } from '@/services/app/getInvoiceLines'
import getNestedValue from '@/services/functions/getNestedValue'
import setNestedValue from '@/services/functions/setNestedValue'
import _, { cloneDeep } from 'lodash'

export default {
  name: 'step4-line',
  components: {
    // Loading,
    ListLayoutTwoColumnsNoFixed,
    FilterPanel,
    KendoGridComponent,
    ImportProductsDialog
  },
  props: {
    step: Object,
    value: [Number, String],
    isFirstStep: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      // Searches
      saveSearchDialog: false,
      // All
      ImportProductsDialog: false,
      multipleFilters: TIPOS_FILTER_MULTIPLE,
      spanish: true,
      vuexnamespace: 'invoicesIssuing/4',
      selectedField: 'selected',
      inEditField: 'inEdit',
      expandField: 'expanded',
      // expand: false,
      // expandedItems: [],
      rules: {
        invoiceLines: [
          {
            required: true,
            message: i18n.t('invoices.invoices_issuing.step4.one_invoice_line_required'),
            trigger: ['blur', 'change']
          }
        ]
      },
      filterPanel: false,
      loadingDataTable: false,
      data: [],
      selected: [],
    }
  },
  computed: {
    form: function () {
      return this.$store.getters[this.vuexnamespace + '/form']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    uuidList: function () {
      return this.form.invoiceLines.map(x => x.uuid)
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.kendo.dataResult ? this.kendo.dataResult.data.length : 0
    },
    hasSelected () {
      return this.selected.length > 0
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading || this.loadingCompanies || this.loadingCompanyData || this.loadingContacts
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    isLower1650: function () {
      return this.$store.getters['app/getIsLower1650']
    },
  },
  watch: {
    'form.invoicesLines': {
      deep: true,
      handler: async function () {
        this.data = await this.applyFilters()
      }
    }
  },
  async mounted () {
    this.data = await this.applyFilters()
  },
  methods: {
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    toggleImportProducts: function () {
      this.ImportProductsDialog = !this.ImportProductsDialog
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    dataStateChange: async function (event) {
      this.data = await this.applyFilters()
    },
    getParamsFilter (data) {
      const user = this.$store.getters['auth/user']
      const extraparams = _.cloneDeep(data)
      Object.entries(extraparams).forEach(([key, value]) => { extraparams[key] = this.discard(['label', 'value'], value) })
      if (this.value && !extraparams.idCliente) {
        extraparams.idCliente = { comparator: 'equals' }
      }
      return {
        idCliente: data.idCliente ? data.idCliente : null,
        idUsuario: user.IdUsuario,
        codProducto: data.codProducto ? data.codProducto.value : null,
        descripcion: data.descripcion ? data.descripcion.value : null,
        cantidad: data.cantidad ? data.cantidad.value : null,
        cantidadMax: data.cantidadMax ? data.cantidadMax.value : null,
        cantidadMin: data.cantidadMin ? data.cantidadMin.value : null,
        precioUnitarioMax: data.precioUnitarioMax ? data.precioUnitarioMax.value : null,
        precioUnitarioMin: data.precioUnitarioMin ? data.precioUnitarioMin.value : null,
        totalMax: data.totalMax ? data.totalMax.value : null,
        totalMin: data.totalMin ? data.totalMin.value : null,
        descuento: data.descuento ? data.descuento.value : null,
        cuota: data.cuota ? data.cuota.value : null,
        extraparams
      }
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = this.getParamsFilter(data)
      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      try {
        const data = await this.getItemsData(obj, params)
        return data
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
      this.unselect()
      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }
      return data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getInvoiceLines(orders, params)
      if (data.blnError === true) {
        this.doFeedback(`${data.msgError} [${data.codError}]`)
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const index = tag.at(-1)
      const tagName = this.multipleFilters.find(x => new RegExp('^' + x.NombreTag + '\\d*$').test(tag[0]))?.NombreTag
      if (tagName) {
        if (Number.isInteger(index) && Array.isArray(filter[tagName].value) && index > -1 && 
          index < filter[tagName]?.value.length && filter[tagName]?.value.length > 1) {
          filter[tagName].value.splice(index, 1)
        } else {
          delete filter[tagName]
        }
      } else {
        delete filter[tag[0]]
      }
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    removeAllTagsHandler: async function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    unselect: function () {
      if (this.$refs.grid) {
        this.$refs.grid.unselect()
      }
    },
    onHeaderSelectionChange: function ({ selected }) {
      this.selected = selected
    },
    onSelectionChange: function ({ selected }) {
      this.selected = selected
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    validate: function (callback = (valid) => {}, doInput = true) {
      this.$refs.ruleForm.validate(valid => {
        if (valid && doInput && (this.isFirstStep || this.value === '') && [3, 7, 8].includes(this.role)) {
          this.$emit('input', this.form.invoiceLines[0]?.idCliente ?? '')
        }
        callback(valid) 
      })
    },
    resetForm () {
      this.$store.dispatch(this.vuexnamespace + '/resetForm')
      this.data = []
    },
    importProducts: async function (products) {
      products.forEach(product => {
        this.checkProducts(product)
      })
      this.toggleImportProducts()
      this.data = await this.applyFilters()
    },
    mergeLines: async function (oldElement, newParams) {
      oldElement.cantidad = parseFloat(oldElement.cantidad) + parseFloat(newParams.cantidad)
      this.calculateSubTotal(oldElement)
      this.calculateTotal(oldElement)
      this.calculateTotalConImpuesto(oldElement)
      this.data = await this.applyFilters()
    },
    addLine: function (params) {
      try {
        this.$store.commit('setIsLoading', true)
        const linea = {
          ...params,
          uuid: this.generateLineUuid(),
          lineNumber: this.form.invoiceLines.length + 1
        }
        this.form.invoiceLines.push(linea)
        this.validate()
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    checkProducts: async function (params) {
      var merged = false
      if (this.form.invoiceLines.length !== 0) {
        // Comprobamos si ya existe ese producto
        if (this.form.invoiceLines.some(element => element.idProducto === params.idProducto)) {
          for (const element of this.form.invoiceLines) {
            if (element.idProducto === params.idProducto) {
              if (element.descuentos.every(item => 
                params.descuentos.some(x => 
                  x.incluyeDescuento === item.incluyeDescuento && (item.incluyeDescuento ? item.descuento === x.descuento : item.cuota === x.cuota)
                )
              ) && element.taxes.every(item => params.taxes.some(x => x.idImpuesto === item.idImpuesto && x.TaxRate === item.TaxRate))
              ) {
                await this.mergeLines(element, params)
                merged = true
                break
              }
            }
          }
        }
      }
      if (!merged) {
        this.addLine(params)
      }
    },
    deleteLines: async function (event) {
      const selected = Array.isArray(event) ? event : this.selected
      var deleted = false
      for (const line of selected) {
        const index = this.form.invoiceLines.findIndex(x => x.uuid === line.uuid)
        if (index > -1) {
          this.form.invoiceLines.splice(index, 1) // Eliminar
          deleted = true
        }
      }
      if (deleted) {
        this.form.invoiceLines.forEach((x, i) => { x.lineNumber = i + 1 })
        this.data = await this.applyFilters()
      }
      this.unselect()
    },
    generateLineUuid: function () {
      var uuid = ''
      do {
        uuid = crypto.randomUUID()
      } while (this.uuidList.includes(uuid))
      return uuid
    },
    setNestedValue: function (fieldName, dataItem, value, reactable = false) {
      setNestedValue(fieldName, dataItem, value, reactable)
    },
    cloneDeep: function (dataItem) {
      return cloneDeep(dataItem)
    },
    controlCantidad: function (dataItem, cantidad) {
      if (this.isFalsy(cantidad)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.need_cantidad'))
      } else if (cantidad === 0) {
        cantidad = ''
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_cantidad'))
      } else if (cantidad.includes('.') && dataItem.UnitOfMeasure.includes('01')) {
        cantidad = ''
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_product'))
      }
      this.calculateSubTotal(dataItem, cantidad)
      if (dataItem.descuentos[0].incluyeDescuento && this.isNotFalsy(dataItem.descuentos[0].descuento)) {
        this.controlDescuento(dataItem, dataItem.descuentos[0].descuento)
      } else if (!dataItem.descuentos[0].incluyeDescuento && this.isNotFalsy(dataItem.descuentos[0].cuota)) {
        this.controlCuota(dataItem, dataItem.descuentos[0].cuota)
      } else {
        this.calculateTotal(dataItem)
        this.calculateTotalConImpuesto(dataItem) 
      }
    },
    controlCuota: function (dataItem, cuota) {
      var valid = true
      if (cuota !== '' && cuota !== 0 && dataItem.subtotal !== 0 && ((cuota < 0 && dataItem.subtotal > 0) || (cuota > 0 && dataItem.subtotal < 0))) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_cuota', { max: dataItem.subtotal }))
        cuota = ''
        valid = false
      }
      const descuento = cuota !== '' && dataItem.subtotal !== '' ? cuota * 100 / dataItem.subtotal : ''
      setNestedValue('descuento', dataItem.descuentos[0], descuento, true)
      setNestedValue('incluyeDescuento', dataItem.descuentos[0], (cuota !== '' ? false : (valid ? '' : null)), true)
      this.calculateTotal(dataItem)
      this.calculateTotalConImpuesto(dataItem)
    },
    controlDescuento: function (dataItem, descuento) {
      var valid = true
      if (descuento !== '' && (descuento < 0 || descuento > 100)) {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_discount'))
        descuento = ''
        valid = false
      }
      const cuota = descuento !== '' && dataItem.subtotal !== '' ? dataItem.subtotal * descuento / 100 : ''
      setNestedValue('cuota', dataItem.descuentos[0], cuota, true)
      setNestedValue('incluyeDescuento', dataItem.descuentos[0], (descuento !== '' ? true : (valid ? '' : null)), true)
      this.calculateTotal(dataItem)
      this.calculateTotalConImpuesto(dataItem)
    },
    controlImpuestos: function (dataItem, taxes = []) {
      if (this.isFalsy(taxes) && getNestedValue(this.selectedField, dataItem) && this.isNotFalsy(dataItem.cantidad)) {
        this.doFeedback(i18n.t('feedback.error.obligatory_field_error', { field: i18n.t('impuestos.entity_name').toLowerCase() }))
      }
      this.calculateTotalConImpuesto(dataItem)
    },
    calculateSubTotal: function (dataItem, cantidad = dataItem.cantidad) {
      if (this.isNotFalsy(cantidad)) {
        const subtotal = dataItem.precioUnitario * cantidad
        setNestedValue('subtotal', dataItem, subtotal, true)
      } else {
        setNestedValue('subtotal', dataItem, '', true)
      }
    },
    calculateTotal: function (dataItem) {
      if (this.isNotFalsy(dataItem.subtotal) && (dataItem.descuentos[0].editDescuento !== '')) {
        const total = (dataItem.subtotal - (dataItem.descuentos[0].cuota || 0))
        setNestedValue('total', dataItem, total, true)
      } else {
        setNestedValue('total', dataItem, '', true)
      }
    },
    calculateTotalConImpuesto: function (dataItem) {
      if (this.isNotFalsy(dataItem.total) && this.isNotFalsy(dataItem.taxes)) {
        const total = dataItem.total || 0
        dataItem.taxes.forEach(tax => setNestedValue('cuota', tax, total * (tax.TaxRate || 0) / 100, true))
        const cuotaImpuesto = dataItem.taxes.map(tax => tax.cuota || 0).reduce((acc, x) => acc + x, 0)
        const totalConImpuesto = total + cuotaImpuesto
        setNestedValue('totalConImpuesto', dataItem, totalConImpuesto, true)
      } else {
        setNestedValue('totalConImpuesto', dataItem, '', true)
      }
    },
    formatNumberWithDefault: function (number, format = 'currency_8', vdefault = ' - ') {
      if (this.isFalsy(number)) {
        return vdefault
      }
      return i18n.n(number, format)
    },
    taxValue: function (option) {
      return option
    },
    isNotFalsy: function (value) {
      if (Array.isArray(value)) {
        return value.length && value.every(x => this.isNotFalsy(x))
      }
      return ![undefined, null, false, ''].includes(value)
    },
    isFalsy: function (value) {
      return !this.isNotFalsy(value)
    },
    checkLine: function (scope, save) {
      if (scope.totalConImpuesto === undefined || scope.totalConImpuesto === null || scope.totalConImpuesto === '') {
        this.doFeedback(i18n.t('invoices.invoices_issuing.step4.valid_total'))
      } else {
        this.updateLine(scope)
        save()
      }
    },
    updateLine: function (scope) {
      const line = this.form.invoiceLines.find(x => x.uuid === scope.uuid)
      Object.keys(line).forEach(key => {
        line[key] = scope[key]
      })
    }
  },
}
</script>

<style scoped>
  @media (width < 1630px) {
    ::v-deep .table-tools > :first-child{
      gap: 0.5rem;
      flex-direction: column;
      justify-content: center;
    }
  }

.layout-list-two-columns-no-fixed::v-deep .left-col > .content {
  @apply px-4 lg:px-10
}
</style>
